<template>
  <section class="missing">
    <div class="missing__spiff-wrapper">
      <img
        class="missing__spiff"
        src="@/assets/images/error-handling/Spiff.png"
      />
    </div>
    <div class="missing__error-msg-wrapper">
      <div class="missing__error-msg">how did you get way out here?</div>
      <div class="missing__home-btn-wrapper">
        <router-link :to="{ name: 'home' }" class="missing__home-btn"
          >return home</router-link
        >
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Missing',
  created() {
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.missing {
  min-height: 100vh;
  background-image: url('https://s3.amazonaws.com/my.ine.com/assets/error/404_planet.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  &__spiff-wrapper {
    margin: 0 auto;
    width: 100%;
    text-align: center;
    padding-top: 100px;
  }
  &__error-msg-wrapper {
    margin: 0 auto;
    width: 100%;
    text-align: center;
  }
  &__error-msg {
    color: var(--white);
    font-size: 2rem;
    text-transform: uppercase;
    font-weight: 700;
  }
  &__home-btn-wrapper {
    margin-top: 50px;
  }
  &__home-btn {
    text-decoration: none;
    color: var(--white);
    font-size: 1rem;
    text-transform: uppercase;
    border: 3px solid var(--orange);
    padding: 10px 20px;
    border-radius: 30px;
    transition: 0.5s all ease;
    &:hover {
      color: var(--black);
      background-color: var(--white);
    }
  }
}
</style>
